import React, { useEffect, useRef, useState } from 'react';
import FastbetDropdown from '../../common/FastbetDropdown';
import MoreBetsOdd from '../../common/MoreBetsOdd';
import Odd from '../../common/Odd';
import UOBox from '../../common/UOBox';
import PrematchContext from '../../contexts/PrematchContext';
import { LIST_BETS_HANDICAP_TYPES, MAX_COLUMNS } from '../../data/constants';
import { isSeoSettingsNoFollow } from '../../data/seo/seoUtils';
import { useAbsolutePath } from '../../data/seo/seoRouteUtils';
import { getBetDescription, getConfiguration, getEncodedURI } from '../../data/utils';
import { CustomCols } from '../../live/Live';
import { checkForDashClass } from '../../tables-utils';
import { useUISettings, useUISettingsDispatch } from '../../UISettingsProvider';
import ListBetLayout from './ListBetsLayout';
import MoreBets from './MoreBets';
import Jersey from '../../common/jerseys/Jersey';
import { BetslipSelectionsContext } from '../../data/betslip/BetslipSelectionsConf';
import StatsToggle from '../../common/StatsToggle';
import PrematchHomeContext from '../../contexts/PrematchHomeContext';

const SECTIONS = ['prematch-home', 'top-match'];

function TournamentBets(props) {
    const prematchContext = React.useContext(PrematchContext);
    const prematchHomeContext = React.useContext(PrematchHomeContext);
    const uiSettings = useUISettings();
    const dispatch = useUISettingsDispatch();
    const betslipSelectionsContext = React.useContext(BetslipSelectionsContext);
    const customCols = React.useContext(CustomCols);
    const [toggled, setToggled] = useState(prematchContext.match?.openedFromBanner ?? false);
    const [isActive, setIsActive] = useState(false)
    const conf = getConfiguration();

    function openMatchColumn() {
        if (uiSettings.fullScreen) {
            dispatch({ type: 'setFullscreen', isFullScreen: false });
            setIsActive(true)
        } else if (match.id === prematchHomeContext?.match?.id) {
            dispatch({ type: 'setFullscreen', isFullScreen: true });
            setIsActive(false)
        }
        props.openMatch(match, absoluteMatchPath, match.urlPath);
    }
    function toggleMoreBets() {
        if (conf.iwh) {
            openMatchColumn();
        } else if (uiSettings.fullScreen || conf.pls === 'LANDING_WIDGETS') {
            setToggled(!toggled);
        }
    }

    const match = props.match;
    const isInBetslip = betslipSelectionsContext.isEventSelected(match.pal, match.avv);

    function handleClick(url) {
        if (conf.iwh) {
            openMatchColumn();
        } else if (prematchContext.section === 'event-search' || (conf.pls === 'LANDING_WIDGETS' && SECTIONS.includes(prematchContext.section))) {
            props.openMatch(match, url, match.urlPath);
        } else if (uiSettings.fullScreen || prematchContext.section === 'extra-events') {
            setToggled(!toggled);
        } else {
            props.openMatch(match, url, match.urlPath);
        }
    }

    useEffect(() => {
        if (!uiSettings.fullScreen) {
            setIsActive(true);
        }
    }, [uiSettings.fullScreen]);

    function handleClickHref(url, e) {
        e.preventDefault();
    }

    const absoluteMatchPath = useAbsolutePath(match.urlPath, null, match.urlPathSeo);
    const noFollow = isSeoSettingsNoFollow(match.urlPathSeoSettings);
    const moreBetsToggled = (uiSettings.fullScreen || prematchContext.section === 'extra-events' || conf.pls === 'LANDING_WIDGETS') && toggled;

    // Adatta il nome del match in base allo spazio disponibile
    const matchDesc = useRef(null);
    useEffect(() => {
        const handler = () => {
            if (matchDesc.current != null) {
                checkForDashClass(matchDesc.current);
            }
        };

        handler();
        window.addEventListener('resize', handler);
        return () => {
            window.removeEventListener('resize', handler);
        }
    }, [uiSettings.fullScreen, props.agg]);

    const [highlight, setHighlight] = useState(false);
    useEffect(() => {
        let timeoutId = null;

        if (conf?.otas !== 'just_match' && props.highlight) {
            setHighlight(true);
            timeoutId = setTimeout(() => {
                setHighlight(false);
            }, 2000);
        }

        return () => {
            clearTimeout(timeoutId);
        }
    }, [props.highlight]);

    let fiveColumnTemplate = false;
    if (match?.gruppiScommessa.length <= 1 && match.avvRef == null) {
        fiveColumnTemplate = true;
    }

    let classes = '';
    if (isInBetslip) {
        classes += ' event-row-selected';
    }
    if (fiveColumnTemplate) {
        classes += ' tabellaQuotePrematch_5col';
    }
    if (highlight) {
        classes += ' rigaQuoteLampeggiante';
    }

    let bets = match.bets;
    let rowBets = [];
    let columnBets = [];
    let showListBetsLayout = false;
    const parametricheMap = new Set();
    const maxColumns = customCols ? customCols : MAX_COLUMNS;
    let columns = 0;
    bets.forEach(bet => {
        if (!LIST_BETS_HANDICAP_TYPES.includes(bet.tipoHandicap) && (bet.forceOddsListColumn || bet.compactView)) {
            if (bet.odds.length > 0) {
                columnBets.push(bet);
            }
            return;
        }

        let nOdds = bet.odds.length;
        if (bet.parametrica) {
            if (LIST_BETS_HANDICAP_TYPES.includes(bet.tipoHandicap)) {
                if (!showListBetsLayout) {
                    showListBetsLayout = true;
                }
                return;
            } else {
                nOdds++;
            }
        }
        if (nOdds > maxColumns && bet.parametrica) {
            columnBets.push(bet);
        } else {
            if (columns + nOdds <= maxColumns) {
                if (bet.parametrica) {
                    if (!parametricheMap.has(bet.id)) {
                        parametricheMap.add(bet.id);
                    } else {
                        return;
                    }
                }
                columns += nOdds;
                rowBets.push(bet);
            }
            else {
                    if (!bet.parametrica && bet.odds.length > maxColumns) {
                        columnBets.push(bet);
                    }
            }
        }
    });
    bets = bets.filter(bet => {
        if (bet.forceOddsListColumn || LIST_BETS_HANDICAP_TYPES.includes(bet.tipoHandicap)) {
            bet.odds = bet.odds.filter(o => o.value != null);
            return bet.hasOdds;
        } else {
            return true;
        }
    });

    if (showListBetsLayout) {
        bets = bets.filter(b => {
            if (b.odds.length === 0) {
                return false;
            }
            return b.odds[0].value != null;
        });
        if (bets.length === 0) {
            return null;
        }
    }

    const getClassName = (matchId, prematchHomeContext, isActive) => {
        return matchId === prematchHomeContext?.match?.id && isActive ? 'active' : 'notActive';
    };

    return (
        <div className="contenitoreRiga" key={`tournament-match-${match.id}`}>
            <div className={"tabellaQuoteNew text_s1 tabellaQuotePrematch mb-2" + classes}>
                <div className="tabellaQuoteAlias d-flex justify-content-center align-items-center">
                    <p>{match.alias}</p>
                </div>
                <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                    <p>
                        <span className="tabellaQuoteTempo__data">{match.date}</span>
                        <span className="tabellaQuoteTempo__separatore">-</span>
                        <span className="tabellaQuoteTempo__ora">{match.time}</span>
                    </p>
                </div>
                <div ref={matchDesc} className={`tabellaQuoteSquadre pointer ${getClassName(match.id, prematchHomeContext, isActive)}`} onClick={handleClick.bind(this, absoluteMatchPath)}>
                    <a href={getEncodedURI(absoluteMatchPath)} onClick={handleClickHref.bind(this, absoluteMatchPath)} {...(noFollow ? { rel: 'nofollow' } : {})} ></a>
                    {props.showTournamentDesc &&
                        <p className="font-weight-bold m-0 text-right tournament-desc">
                            {match.tournamentDesc}
                        </p>
                    }
                    <div className="d-flex items-center">
                        {match.team2 &&
                            <Jersey data={match.jerseys?.[0]} type={'home'} sportRef={match.sportRef} />
                        }
                        <p className="font-weight-bold m-0 text-right" title={match.team1}>
                            {match.team1}
                        </p>
                    </div>
                    <p className="font-weight-bold colore-1 m-0 px-2 tabellaQuoteSquadreSeparatore">
                        {match.team2 == null ? '' : 'vs'}
                    </p>
                    {match.team2 &&
                        <div className="d-flex items-center">
                            <Jersey data={match.jerseys?.[1]} type={'away'} sportRef={match.sportRef} />
                            <p className="font-weight-bold m-0 text-left" title={match.team2}>
                                {match.team2}
                            </p>
                        </div>
                    }
                </div>
                <div className="tabellaQuoteStatistiche">
                    <StatsToggle className="fas fa-chart-bar stat-sel pointer" match={match} />
                </div>
                {!fiveColumnTemplate &&
                    <div className="tabellaQuoteAltre d-flex justify-content-end align-items-center pr-2">
                        <FastbetDropdown id={match.id} match={match} moreBetsToggled={moreBetsToggled} toggleMoreBets={toggleMoreBets} />
                    </div>
                }
                <div className="tabellaQuoteContenitoreQuotazioni">
                    {rowBets.map(bet => {
                        const betUniqueId = `${bet.uniqueId}`;
                        return (
                            <div key={betUniqueId} className="contenitoreSetQuotazioni">
                                <div className="tipologiaQuotazione_FormaCompatta grigio text-center py-1">
                                    <p>{getBetDescription(bet, true)}</p>
                                </div>
                                {bet.parametrica ?
                                    <UOBox betId={bet.id} bets={match.betsById.get(bet.id)} />
                                    :
                                    <div className="gridInterernaQuotazioni">
                                        {bet.odds.map(odd => {
                                            const id = `${odd.betId}_${odd.betData.handicap}_${odd.id}`;
                                            return <Odd key={id} {...odd} isLastMinute={props.isLastMinute} />
                                        })}
                                    </div>
                                }
                            </div>
                        )
                    })}
                    {showListBetsLayout &&
                        <ListBetLayout key={props.agg} id={props.agg} betsById={match.betsById} />
                    }
                </div>
            </div>
            {columnBets.map(bet => {
                const betUniqueId = `collapse-${bet.uniqueId}`;
                const betDesc = getBetDescription(bet, false, match.sportRef, columnBets);
                return (
                    <React.Fragment key={betUniqueId}>
                        <div className="tabellaQuoteRisultatoEsattoEspandi pointer toggle-nascondi-live mb-2" data-toggle="collapse" href={`#${betUniqueId}`} role="button" aria-expanded="true" aria-controls={betUniqueId}>
                            {/* <p>{bet.handicapDesc ? `${bet.desc} ${bet.handicapDesc}` : getBetDescription(bet, true)}</p> */}
                            <p>{betDesc}</p>
                        </div>
                        <div id={betUniqueId} className="collapse show">
                            <div className="risultatoEsattoGrid text_s1">
                                {bet.odds.map(odd =>
                                    <MoreBetsOdd key={`${odd.betId}_${odd.betData.handicap}_${odd.id}`} {...odd} noHandicap={true} />
                                )}
                            </div>
                        </div>
                    </React.Fragment>
                )
            })}
            {moreBetsToggled &&
                <MoreBets match={match} aggregata={props.agg} />
            }
        </div>
    );
}

export default TournamentBets;